
var _Aztec = require('./components/Aztec')

module.exports = {
  Aztec: _Aztec.Aztec
}
